import { router } from "@inertiajs/react";
import { useCallback } from "react";
import type { SearchParams } from "@/pages/job_search";
import type { RecentSearch } from "@/types/job_search/recent_searches";
import type { Location } from "@components/ui/location_input";
import type { VisitOptions } from "@inertiajs/core";

export type SearchSource = "popover";

export function useJobSearch() {
  return useCallback((params: SearchParams, options?: VisitOptions) => {
    // Tag deliberate searches so the server honors them instead of redirecting
    // to the user's default filters — even when the search is empty (cleared).
    router.get("/jobs", params, {
      ...options,
      headers: { ...options?.headers, "X-Job-Search": "true" },
    });
  }, []);
}

export const buildJobsParams = (
  query: string | undefined,
  location: Location | null,
  extraFilters: Partial<RecentSearch> = {},
  source?: SearchSource,
): SearchParams => ({
  query: query || undefined,
  location: location?.display_name,
  lat: location?.latitude,
  lon: location?.longitude,
  location_type: location?.location_type || undefined,
  country_short_name: location?.country_short_name || undefined,
  state_short_name: location?.state_short_name || undefined,
  date_posted: extraFilters.date_posted || undefined,
  salary: extraFilters.salary || undefined,
  work_type: extraFilters.work_type?.length ? extraFilters.work_type : undefined,
  employment_type: extraFilters.employment_type?.length ? extraFilters.employment_type : undefined,
  search_source: source,
});

export const recentSearchToLocation = (search: RecentSearch): Location | null =>
  search.location
    ? {
        display_name: search.location,
        latitude: search.lat || 0,
        longitude: search.lon || 0,
        country_short_name: search.country_short_name,
        state_short_name: search.state_short_name,
        location_type: search.location_type,
      }
    : null;
